// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/radio/Disabled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { view, deprecatedCss } from '@sail/engine';
import { Radio } from '@sail/ui';
export const Disabled = () => {
  return <view.div uses={[deprecatedCss`
          layout: column;
        `]}>
      <Radio name="group2" label="Ah ah ah" disabled />
      <Radio name="group2" disabled checked label="You didn't say the magic word" />
    </view.div>;
};